import { __makeTemplateObject, __assign, __rest } from 'tslib';
import { tint as curriedTint$1, shade as curriedShade$1 } from '../../../node_modules/polished/dist/polished.esm.js';
import React__default, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { backgroundColor, typography, space, layout, borders } from '../../../node_modules/@xstyled/system/dist/xstyled-system.es.js';
import { shouldForwardProp } from '../../should-forward-prop.js';
import { flexboxes } from '../../system.js';

var defaultStyles = {
  fontFamily: "heading",
  backgroundColor: "transparent",
  borderWidth: 0,
  borderStyle: "none",
  boxSizing: "border-box",
  padding: 0,
  color: "text.button",
  extra: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    cursor: pointer;\n    appearance: none;\n    outline: 0;\n    &:hover {\n      color: ", ";\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.5;\n      color: ", ";\n      &:hover {\n        color: ", ";\n      }\n    }\n  "], ["\n    cursor: pointer;\n    appearance: none;\n    outline: 0;\n    &:hover {\n      color: ", ";\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.5;\n      color: ", ";\n      &:hover {\n        color: ", ";\n      }\n    }\n  "])), function (_a) {
    var theme = _a.theme,
      hoverColor = _a.hoverColor;
    return hoverColor && theme.colors[hoverColor] || hoverColor || theme.colors.mofoBrand;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.text.button;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.text.button;
  })
};
var buttonVariants = {
  primary: __assign(__assign({}, defaultStyles), {
    fontSize: 2,
    fontWeight: "bold",
    borderRadius: "100px",
    padding: "16px 20px",
    lineHeight: "none",
    color: "white",
    backgroundColor: "mofoPrimary",
    borderColor: "mofoPrimary",
    borderWidth: "1px",
    extra: defaultStyles.extra.concat(css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      &:hover,\n      &:focus {\n        color: ", ";\n\n        border-color: ", ";\n        background-color: ", ";\n      }\n\n      &:active {\n        border-color: ", ";\n        background-color: ", ";\n      }\n\n      &:disabled {\n        border-color: ", ";\n        background-color: ", ";\n        cursor: not-allowed;\n        opacity: 0.5;\n      }\n    "], ["\n      &:hover,\n      &:focus {\n        color: ", ";\n\n        border-color: ", ";\n        background-color: ", ";\n      }\n\n      &:active {\n        border-color: ", ";\n        background-color: ", ";\n      }\n\n      &:disabled {\n        border-color: ", ";\n        background-color: ", ";\n        cursor: not-allowed;\n        opacity: 0.5;\n      }\n    "])), function (_a) {
      var theme = _a.theme,
        hoverColor = _a.hoverColor;
      return hoverColor && theme.colors[hoverColor] || hoverColor || theme.colors.white;
    }, function (_a) {
      var theme = _a.theme;
      return curriedTint$1(0.1, theme.colors.mofoPrimary);
    }, function (_a) {
      var theme = _a.theme;
      return curriedTint$1(0.1, theme.colors.mofoPrimary);
    }, function (_a) {
      var theme = _a.theme;
      return curriedShade$1(0.1, theme.colors.mofoPrimary);
    }, function (_a) {
      var theme = _a.theme;
      return curriedShade$1(0.1, theme.colors.mofoPrimary);
    }, function (_a) {
      var theme = _a.theme;
      return theme.colors.disabled;
    }, function (_a) {
      var theme = _a.theme;
      return theme.colors.disabled;
    }))
  }),
  outline: __assign(__assign({}, defaultStyles), {
    fontSize: 2,
    fontWeight: 500,
    borderRadius: "100px",
    padding: "14px 18px",
    lineHeight: "none",
    backgroundColor: "white",
    border: "2px solid",
    borderColor: "mofoPrimary",
    extra: defaultStyles.extra.concat(css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      &:hover,\n      &:focus {\n        color: ", ";\n\n        border-color: ", ";\n        background-color: ", ";\n      }\n\n      &:active {\n        border-color: ", ";\n        background-color: ", ";\n      }\n\n      &:disabled {\n        border-color: ", ";\n        background-color: ", ";\n        cursor: not-allowed;\n        opacity: 0.5;\n      }\n    "], ["\n      &:hover,\n      &:focus {\n        color: ", ";\n\n        border-color: ", ";\n        background-color: ", ";\n      }\n\n      &:active {\n        border-color: ", ";\n        background-color: ", ";\n      }\n\n      &:disabled {\n        border-color: ", ";\n        background-color: ", ";\n        cursor: not-allowed;\n        opacity: 0.5;\n      }\n    "])), function (_a) {
      var theme = _a.theme,
        hoverColor = _a.hoverColor;
      return hoverColor && theme.colors[hoverColor] || hoverColor || theme.colors.black;
    }, function (_a) {
      var theme = _a.theme;
      return curriedTint$1(0.1, theme.colors.mofoPrimary);
    }, function (_a) {
      var theme = _a.theme;
      return curriedTint$1(0.95, theme.colors.mofoPrimary);
    }, function (_a) {
      var theme = _a.theme;
      return curriedShade$1(0.1, theme.colors.mofoPrimary);
    }, function (_a) {
      var theme = _a.theme;
      return curriedTint$1(0.95, theme.colors.mofoPrimary);
    }, function (_a) {
      var theme = _a.theme;
      return theme.colors.disabled;
    }, function (_a) {
      var theme = _a.theme;
      return theme.colors.white;
    }))
  }),
  default: __assign({}, defaultStyles)
};
var StyledButton = /*#__PURE__*/styled("button").withConfig({
  shouldForwardProp: function (prop, defaultValidtorFn) {
    return shouldForwardProp(prop) && defaultValidtorFn(prop);
  },
  displayName: "Button__StyledButton",
  componentId: "sc-aufvcf-0"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), backgroundColor, flexboxes, typography, space, layout, borders, function (_a) {
  var extra = _a.extra;
  return extra !== null && extra !== void 0 ? extra : extra;
});
var Button = forwardRef(function (_a, ref) {
  var variant = _a.variant,
    rest = __rest(_a, ["variant"]);
  var styles = buttonVariants[variant];
  return React__default.createElement(StyledButton, __assign({
    ref: ref
  }, styles, rest));
});
Button.defaultProps = {
  variant: "default"
};
Button.displayName = "Button";
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

export { Button, StyledButton, buttonVariants };
//# sourceMappingURL=Button.js.map
